var map = {
	"./common/router": "vYYM",
	"./erp/router": "yWRS",
	"./system/router": "b8IG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "paBj";


//////////////////
// WEBPACK FOOTER
// ./src/modules ^\.\/.*\/router$
// module id = paBj
// module chunks = 1